export enum dataTypeValue {
    VARCHAR= "1",
    SMALLINT= "2",
    INT= "3",
    WORD= "4",
    FLOAT= "6",
    DATE= "9",
    DATETIME= "11"
}